module.exports = __webpack_public_path__ + "static/media/arrow.7aa547f0.svg";